import { forwardRef, useImperativeHandle, useState } from "react";
import SaleListService from '../../services/SaleListService';
import PrintTemplateService from '../../services/PrintTemplateService';

const SaleReceipt = forwardRef((props, ref) => {
    const [data, setData] = useState(null);
    const [template, setTemplate] = useState('');
    const [mode, setMode] = useState('info'); // 'info', 'collection', 'detailed'

const isTemplateEmpty = (html) => {
    if (!html) return true;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // br etiketleri içerik sayılmasın
    doc.querySelectorAll('br').forEach(x => x.remove());

    const text = (doc.body.textContent || '')
        .replace(/\u00a0/g, '') // &nbsp;
        .replace(/\u200B/g, '') // zero-width space
        .trim();

    return text.length === 0;
};
    const print = async (saleId, printMode = 'info') => {
        if (!saleId) return;
        try {
            const saleData = await SaleListService.getSaleDetail(saleId);
            if (saleData) {
                await printWithData(saleData, printMode);
            }
        } catch (error) {
            console.error("Fiş alınamadı:", error);
        }
    };

    const printWithData = async (saleData, printMode = 'info') => {
        if (!saleData) return;
        try {
            // Get custom template from backend
            const templateRes = await PrintTemplateService.getTemplate(printMode);
            let content = '';

            if (templateRes.success && templateRes.data && !isTemplateEmpty(templateRes.data.content)) {
                content = templateRes.data.content;
            } else {
                // Fallback to hardcoded templates if not found
                content = getFallbackTemplate(printMode);
            }

            setData(saleData);
            setMode(printMode);
            setTemplate(processTemplate(content, saleData, printMode));

            // Ensure the state is updated and the DOM is ready
            setTimeout(() => {
                window.print();
            }, 1000);
        } catch (error) {
            console.error("Yazdırma sırasında hata:", error);
        }
    };

    const fmtMoney = (v) => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(v ?? 0);
    const fmtDate = (isoOrDate) => (isoOrDate ? new Date(isoOrDate).toLocaleString("tr-TR", { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : "");

    const getFallbackTemplate = (mode) => {
        // Same as defaultTemplates in PrintSettingsPage
        if (mode === 'info') {
            return `<div style="text-align: center; border-bottom: 1px dashed #000; padding-bottom: 5px; margin-bottom: 10px;">
                <div style="font-size: 14pt; font-weight: bold; text-transform: uppercase;">{{FirmaAdi}}</div>
                <div style="font-size: 10pt;">{{FirmaAdresi}}</div>
                <div style="font-size: 10pt;">{{FirmaTelefon}}</div>
                <div style="font-size: 12pt; margin-top: 5px; font-weight: bold; text-decoration: underline;">BİLGİ FİŞİ</div>
            </div>
            <div style="font-size: 10pt; line-height: 1.2; margin-bottom: 10px;">
                <div><strong>Satış Tarihi:</strong> {{SatisTarihi}}</div>
                <div><strong>Fiş No:</strong> {{FisNo}}</div>
                <div><strong>Müşteri:</strong> {{MusteriAdi}}</div>
                <div><strong>Telefon:</strong> {{MusteriTelefon}}</div>
            </div>
            {{UrunTablosu}}`;
        } else if (mode === 'detailed') {
            return `<div style="text-align: center; border-bottom: 1px dashed #000; padding-bottom: 5px; margin-bottom: 10px;">
                <div style="font-size: 14pt; font-weight: bold; text-transform: uppercase;">{{FirmaAdi}}</div>
                <div style="font-size: 10pt;">{{FirmaAdresi}}</div>
                <div style="font-size: 10pt;">{{FirmaTelefon}}</div>
                <div style="font-size: 12pt; margin-top: 5px; font-weight: bold; text-decoration: underline;">DETAYLI BİLGİ FİŞİ</div>
            </div>
            <div style="font-size: 10pt; line-height: 1.2; margin-bottom: 10px;">
                <div><strong>Satış Tarihi:</strong> {{SatisTarihi}}</div>
                <div><strong>Fiş No:</strong> {{FisNo}}</div>
                <div><strong>Müşteri:</strong> {{MusteriAdi}}</div>
                <div><strong>Adres:</strong> {{MusteriAdresi}}</div>
                <div><strong>Telefon:</strong> {{MusteriTelefon}}</div>
            </div>
            {{UrunTablosu}}
            <div style="border-top: 2px solid #000; margin-top: 10px; padding-top: 5px; font-weight: bold;">
                <div style="display: flex; justify-content: space-between;">
                    <span>GENEL TOPLAM:</span>
                    <span>{{GenelToplam}}</span>
                </div>
                <div style="display: flex; justify-content: space-between;">
                    <span>MÜŞTERİ BAKİYESİ:</span>
                    <span>{{MusteriBakiyesi}}</span>
                </div>
            </div>
            <div style="margin-top: 10px; text-align: center; border: 1px dotted #000; padding: 5px;">
                {{SatisNotu}}
            </div>
            <div style="margin-top: 20px; text-align: center; border: 2px dashed #000; padding: 10px;">
                <div style="font-weight: bold; text-transform: uppercase;">Teslim Alan</div>
                <div style="margin-top: 5px;">{{MusteriAdi}}</div>
                <div style="margin-top: 30px; border-top: 1px solid #000; width: 80%; margin-left: 10%;"></div>
            </div>`;
        } else if (mode === 'collection') {
            return `<div style="text-align: center; border-bottom: 1px dashed #000; padding-bottom: 5px; margin-bottom: 10px;">
                <div style="font-size: 14pt; font-weight: bold; text-transform: uppercase;">{{FirmaAdi}}</div>
                <div style="font-size: 10pt;">{{FirmaAdresi}}</div>
                <div style="font-size: 10pt;">{{FirmaTelefon}}</div>
                <div style="font-size: 12pt; margin-top: 5px; font-weight: bold; text-decoration: underline;">TAHSİLAT MAKBUZU</div>
            </div>
            <div style="font-size: 10pt; line-height: 1.5;">
                <div><strong>Müşteri Adı:</strong> {{MusteriAdi}}</div>
                <div><strong>Telefon:</strong> {{MusteriTelefon}}</div>
                <div><strong>Tarih:</strong> {{SatisTarihi}}</div>
                <div><strong>Ödeme Yöntemi:</strong> {{OdemeYontemi}}</div>
                <div style="font-size: 12pt; font-weight: bold; border-top: 1px solid #000; margin-top: 5px; padding-top: 5px;">
                    <strong>Ödenen Tutar:</strong> {{OdenenTutar}}
                </div>
                <div style="margin-top: 10px; font-style: italic;">
                    <strong>Açıklama:</strong> {{SatisNotu}}
                </div>
            </div>`;
        }
        return '';
    };
const escapeRegExp = (value) => {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const replaceDesignToken = (html, token, replacement) => {
    const escapedToken = escapeRegExp(token);

    // Quill çoğu zaman token'ı <p>{{DuzCizgi}}</p> olarak tuttuğu için
    // önce komple p bloğunu değiştiriyoruz.
    html = html.replace(
        new RegExp(`<p>\\s*${escapedToken}\\s*</p>`, 'g'),
        replacement
    );

    // Eğer span/div içinde kaldıysa veya düz metinse onu da değiştiriyoruz.
    html = html.replace(
        new RegExp(escapedToken, 'g'),
        replacement
    );

    return html;
};

const processDesignElements = (html) => {
    let result = html || '';

    const solidLine = `<div class="receipt-line receipt-line-solid"></div>`;
    const dashedLine = `<div class="receipt-line receipt-line-dashed"></div>`;
    const dottedLine = `<div class="receipt-line receipt-line-dotted"></div>`;
    const space = `<div class="receipt-space"></div>`;

    const signatureArea = `
        <div class="receipt-sign-area">
            <div class="receipt-sign-line"></div>
            <div class="receipt-sign-text">İmza</div>
        </div>
    `;

    // Türkçe karakterli ve karaktersiz iki ihtimali de destekleyelim.
    result = replaceDesignToken(result, '{{DuzCizgi}}', solidLine);
    result = replaceDesignToken(result, '{{DüzCizgi}}', solidLine);

    result = replaceDesignToken(result, '{{KesikCizgi}}', dashedLine);
    result = replaceDesignToken(result, '{{KesikÇizgi}}', dashedLine);

    result = replaceDesignToken(result, '{{NoktaliCizgi}}', dottedLine);
    result = replaceDesignToken(result, '{{NoktalıÇizgi}}', dottedLine);

    result = replaceDesignToken(result, '{{Bosluk}}', space);
    result = replaceDesignToken(result, '{{Boşluk}}', space);

    result = replaceDesignToken(result, '{{ImzaAlani}}', signatureArea);
    result = replaceDesignToken(result, '{{İmzaAlanı}}', signatureArea);
    result = replaceDesignToken(
        result,
        '{{KaseAlani}}',
        `
        <div class="receipt-stamp-sign-area">
            <div class="receipt-stamp-box">Kaşe</div>
        </div>
        `
    );
    return result;
};
    const processTemplate = (html, saleData, printMode) => {
        let result = html;
           result = processDesignElements(result);
         const replacements = {
        '{{FirmaAdi}}': saleData.companyName || "---",
        '{{FirmaAdresi}}': saleData.companyAddress || "---",
        '{{FirmaTelefon}}': saleData.companyPhone || "---",
        '{{SatisTarihi}}': fmtDate(saleData.saleDate),
        '{{FisNo}}': saleData.saleNo || "---",
        '{{MusteriNo}}': saleData.customerId || "---",
        '{{MusteriAdi}}': saleData.customerName || "---",
        '{{MusteriAdresi}}': saleData.customerAddress || "---",
        '{{MusteriTelefon}}': saleData.customerPhone || "---",
        '{{MusteriBakiyesi}}': fmtMoney(saleData.customerBalance),
        '{{OdemeYontemi}}': (saleData.payments || []).map(p => p.method).join(', ') || "Nakit",
        '{{OdenenTutar}}': fmtMoney(saleData.paidTotal),
        '{{GenelToplam}}': fmtMoney(saleData.grandTotal),
        '{{SatisNotu}}': saleData.saleNote || "",
        '{{FirmaFisNotu}}': saleData.companyReceiptNote || "",
        '{{UrunTablosu}}': renderItemTable(saleData, printMode)
    };

    const teslimAlanHtml = `
        <div style="margin-top: 20px; text-align: center; border: 2px dashed #000; padding: 10px;">
            <div style="font-weight: bold; text-transform: uppercase;">Teslim Alan</div>
            <div style="margin-top: 5px;">${saleData.customerName || "---"}</div>
            <div style="margin-top: 30px; border-top: 1px solid #000; width: 80%; margin-left: 10%;"></div>
        </div>
    `;

    result = result.replace(/{{TeslimAlan}}/g, teslimAlanHtml);

    Object.keys(replacements).forEach(key => {
        result = result.replace(new RegExp(key, 'g'), replacements[key]);
    });

    return result;
    };

    const renderItemTable = (saleData, printMode) => {
        if (printMode === 'info') {
            return `
                <div style="border-top: 1px solid black; display: flex; justify-content: space-between; font-weight: bold; font-size: 9.5pt; margin-bottom: 2px;">
                    <span>Ürün Adı</span>
                    <span>Adet</span>
                </div>
                <div style="margin-bottom: 10px;">
                    ${(saleData.items || []).map(item => `
                        <div style="display: flex; justify-content: space-between; font-size: 9.5pt; font-weight: bold; padding: 2px 0; border-bottom: 0.2px solid #ddd;">
                            <span style="flex: 1; padding-right: 5px; word-wrap: break-word;">${item.productName || "---"}</span>
                            <span style="font-weight: bold;">${item.quantity || 0}</span>
                        </div>
                    `).join('')}
                </div>
            `;
        } else {
            // Detailed
            return `
                <table style="width: 100%; border-collapse: collapse; font-size: 9pt; margin-bottom: 10px;">
                    <thead>
                        <tr style="border-bottom: 1px solid black;">
                            <th style="text-align: left; padding: 2px;">Ürün</th>
                            <th style="text-align: center; padding: 2px;">Adet</th>
                            <th style="text-align: right; padding: 2px;">Fiyat</th>
                            <th style="text-align: right; padding: 2px;">Toplam</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${(saleData.items || []).map(item => `
                            <tr>
                                <td style="padding: 2px; border-bottom: 0.1mm solid #eee; font-weight: bold; word-break: break-all;">${item.productName || "---"}</td>
                                <td style="text-align: center; padding: 2px; border-bottom: 0.1mm solid #eee; font-weight: bold;">${item.quantity || 0}</td>
                                <td style="text-align: right; padding: 2px; border-bottom: 0.1mm solid #eee; font-weight: bold;">${(item.unitPrice || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</td>
                                <td style="text-align: right; padding: 2px; border-bottom: 0.1mm solid #eee; font-weight: bold;">${(item.lineTotal || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            `;
        }
    };

    useImperativeHandle(ref, () => ({
        print,
        printWithData
    }));

    if (!data) return null;

    return (
        <div className="print-only">
            <style type="text/css">
                {`
                .print-only { display: none; }
                @media print {
                    @page {
                        size: 76mm auto;
                        margin: 0 !important;
                    }

                    html, body {
                        margin: 0 !important;
                        padding: 0 !important;
                        background: #fff !important;
                        color: #000 !important;
                    }

                    body {
                        width: 76mm !important;
                    }

                    .print-only {
                        display: block !important;
                        width: 72mm !important;
                        margin: 0 !important;
                        padding: 2mm !important;
                        font-family: Verdana, sans-serif;
                        font-size: 8pt;
                        font-weight: 600;
                        line-height: 1.15;
                        box-sizing: border-box;
                        background: white !important;
                        color: black !important;
                    }
                    .ql-align-center { text-align: center; }
                    .ql-align-right { text-align: right; }
                    .ql-align-justify { text-align: justify; }
                    .no-print { display: none !important; }
                    .receipt-line {
    width: 100%;
    height: 0;
    line-height: 0;
    font-size: 0;
    padding: 0;
    margin: 2px 0;
}

.receipt-line-solid {
    border-top: 1px solid #000;
}

.receipt-line-dashed {
    border-top: 1px dashed #000;
}

.receipt-line-dotted {
    border-top: 1px dotted #000;
}

.receipt-space {
    height: 6px;
    line-height: 0;
    font-size: 0;
}

.receipt-sign-area {
    margin-top: 12px;
    text-align: center;
    line-height: 1.1;
}

.receipt-sign-line {
    border-top: 1px solid #000;
    width: 70%;
    margin: 20px auto 0 auto;
    height: 0;
    line-height: 0;
    font-size: 0;
}

.receipt-sign-text {
    font-size: 9pt;
    margin-top: 3px;
}
    .receipt-stamp-sign-area {
    margin-top: 14px;
    text-align: center;
}

.receipt-stamp-box {
    border: 1px dashed #000;
    min-height: 45px;
    padding-top: 6px;
    font-size: 9pt;
    font-weight: bold;
}
                }
                `}
            </style>
            <div dangerouslySetInnerHTML={{ __html: template }} />
        </div>
    );
});

export default SaleReceipt;
